export default __webpack_public_path__ + "78ecc7a5d92b4255d080a3311079af9a.png";